import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

// third-party
import { IntlProvider } from 'react-intl';

// project-imports
import useConfig from 'hooks/useConfig';

// load locales files
const loadLocaleData = (locale) => {
  switch (locale) {
    case 'ar':
      return import('utils/locales/ar.json');
    case 'en':
    default:
      return import('utils/locales/en.json');
  }
};

// ==============================|| LOCALIZATION ||============================== //

const Locales = ({ children }) => {
  const { i18n } = useConfig();

  const [messages, setMessages] = useState(null);

  useEffect(() => {
    let active = true;

    loadLocaleData(i18n)
      .then((d) => {
        if (active) setMessages(d.default);
      })
      .catch(() => {
        // If the requested locale fails to load for any reason, fall back to
        // English so the app never gets stuck on a blank screen.
        loadLocaleData('en').then((d) => {
          if (active) setMessages(d.default);
        });
      });

    return () => {
      active = false;
    };
  }, [i18n]);

  // Always render the app. While messages are (re)loading we pass an empty map
  // so react-intl falls back to message ids — a brief, harmless flash — instead
  // of unmounting the entire UI.
  return (
    <IntlProvider locale={i18n} defaultLocale="en" messages={messages || {}}>
      {children}
    </IntlProvider>
  );
};

Locales.propTypes = {
  children: PropTypes.node,
};

export default Locales;
